import { useCallback } from "react"
import { useQuery, useQueryClient } from "@tanstack/react-query"

import { STATIC_CONFIG_ENV } from "@/configs/static-config"
import { getStaticConfig, type StaticConfig } from "@/services/static-config"

export const STATIC_CONFIG_QUERY_KEYS = {
  DETAIL: ["static-config", STATIC_CONFIG_ENV] as const,
}

export const STATIC_CONFIG_REFETCH_INTERVAL_MS = 2 * 60 * 1000

export function useStaticConfig() {
  return useQuery<StaticConfig>({
    queryKey: STATIC_CONFIG_QUERY_KEYS.DETAIL,
    queryFn: getStaticConfig,
    retry: 1,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchInterval: STATIC_CONFIG_REFETCH_INTERVAL_MS,
    refetchIntervalInBackground: true,
  })
}

export function useRefreshStaticConfig() {
  const queryClient = useQueryClient()

  return useCallback(() => {
    return queryClient.refetchQueries({
      queryKey: STATIC_CONFIG_QUERY_KEYS.DETAIL,
      type: "active",
    })
  }, [queryClient])
}

export function isWebMaintenanceEnabled(config?: StaticConfig): boolean {
  return (
    config?.maintenance?.some(
      (target) => target === "web" || target === "all"
    ) === true
  )
}
